<template>
  <div class="base_box">
    <!-- 地图 -->
    <div id="map" class="container"></div>
    <!-- 左侧信息列表 -->
    <MoreInfo ref="moreinfoRef" @zoomIn="zoomIn" @zoomOut="zoomOut" :info="clickInfo"> </MoreInfo>
    <div class="right_menu" :class="{right_menu_close: !rightBtn}">
      <!-- 右侧按钮 -->
      <div class="right_menu_btn" @click="rightBtn = !rightBtn"><i :class="rightBtn?'el-icon-arrow-right':'el-icon-arrow-left'"></i></div>
      <!-- 有效妈祖庙数量 -->
      <div class="right_title">{{$t("map.mznum")}}: {{templeNum}} </div>
      <div class="right_menu_item card">
        <!-- 信息上传 -->
        <div class="btn" @click="$router.push('/upload')" v-if="visitor"><i class="el-icon-upload2"></i>{{$t("map.upload")}}</div>
        <!-- 全球分布 -->
        <div class="btn" @click="maps.setView([34.1618, 104.9414], 3)"><i class="el-icon-discover"></i>{{$t("map.distribution")}}</div>
        <!-- 妈祖祖庙 -->
        <div class="btn" @click="maps.setView([25.093, 119.144], 15)"><i class="el-icon-location-outline"></i>{{$t("map.origin")}}</div>
      </div>
      <!-- 功能 -->
      <div class="right_menu_item card">
        <!-- 聚类模式 -->
        <div class="switch">
          <el-switch v-model="clusterFlag" active-color="#f14d2b" @change="changecluster">
          </el-switch>
          <span>{{$t("map.cluster")}}</span> <!-- 聚类模式 -->
        </div>
        <!-- 热力图层 -->
        <div class="switch">
          <el-switch v-model="hotmapFlag" active-color="#f14d2b" @change="changehotMap">
          </el-switch>
          <span>{{$t("map.thermodynamic")}}</span> <!-- 热力图层 -->
        </div>
        <!-- 时间序列 -->
        <div class="switch">
          <el-switch v-model="timeLineFlag" active-color="#f14d2b" @change="changeTimeLine">
          </el-switch>
          <span>{{$t("map.timeline")}}</span> <!-- 时间序列 -->
        </div>
        <!-- 祖庙联系-->
        <div class="switch">
          <el-switch v-model="lineFlag" active-color="#f14d2b" @change="changeLine">
          </el-switch>
          <span>{{$t("map.relation")}} <!-- 祖庙联系 -->
          </span>
        </div>
        <!-- 海上丝绸之路 -->
        <div class="switch">
          <el-switch v-model="roadFlag" active-color="#f14d2b" @change="changeRoad">
          </el-switch>
          <!-- 海上丝绸 -->
          <span>{{$t("map.silk")}}
          </span>
        </div>
      </div>
      <div class="right_menu_item">

      </div>
    </div>
    <!-- 时间序列 -->

    <transition enter-active-class="zoomIn" leave-active-class="zoomOut">
      <div class="time_box animated" v-show="timeLineFlag">
        <!-- 世界妈祖庙修建时间序列 -->
        <div class="time_title">{{$t("map.timebar")}}</div>
        <!-- <el-button icon="el-icon-close" class="close" plain @click="closetimeLine" size="mini" circle></el-button> -->

        <div class="time_item">
          <span class="time_btn" @click="playBtn"> {{ playName }} </span>
          <!-- 重置 -->
          <span class="time_btn" plain @click="resetBtn"> {{$t("map.resetting")}}</span>
          <span class="speed_box">
            <!-- 延时 -->
            <span>{{$t("map.delayed")}}(ms): </span>
            <el-input-number size="mini" v-model="timespeed" :step="100" step-strictly :min="100" :max="500">
            </el-input-number>
          </span>
          <!-- 数量   座-->
          <span class="temple_num">{{$t("map.num")}}：{{ timeTempleNum }} {{$t("map.s")}}</span>
          <!-- 时间： -->
          <span class="time_year">{{$t("map.time")}}：{{ timeValue }} {{$t("map.year")}}</span>
        </div>
        <el-slider v-model="timeValue" :min="minYear" :max="maxYear" @change="timeLine" :marks="dynasty"></el-slider>
      </div>
    </transition>

  </div>
</template>

<script>
import MoreInfo from "../../components/Moreinfo.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    MoreInfo,
    // TimeLine,
  },
  name: "Map",
  data() {
    return {
      rightBtn: true,
      geoData: {}, //geojson对象
      templeNum: 0, //有效妈祖庙数量（有坐标）
      maps: null, //地图
      //祖庙联系
      lineFlag: false,
      lineList: [],
      //聚类图层
      pointGroup: null, //默认显示的点位
      clusterGroup: null, //聚类图层
      clusterFlag: false,
      //热力图层
      hotmapGroup: null, //热力图层
      hotPoint: null, //热力图点位
      hotmapFlag: false,
      // 时间序列
      timeGroup: null, //时间序列图层
      timeLineFlag: false, //时间序列
      timeValue: 987,
      timeTempleNum: 0,
      minYear: 987,
      maxYear: null,
      playFlag: false, //开始按钮标记

      timespeed: 200, //时间轴速度
      timer: null, //存储延时器，用于停止延时器

      // 丝绸之路
      roadFlag: false,
      roadMaker: null,
      roadLine: [],
      // 点样式
      pointOptions: {
        radius: 6,
        fillColor: "#f14d2b",
        color: "#333",
        weight: 1,
        opacity: 1,
        fillOpacity: 1,
      },
      clickInfo: {}, //当前点击的庙宇信息

      a: [],
    };
  },
  computed: {
    visitor: () => {
      let user = JSON.parse(sessionStorage.getItem("user"));
      if (user.userAccount == "visitor") {
        return false;
      } else {
        return true;
      }
    },

    playName() {
      return this.$t("map.start");
    },

    dynasty() {
      return {
        1279: this.$t("map.song"), // 宋
        1368: this.$t("map.yuan"), //元
        1644: this.$t("map.ming"), //明
        1912: this.$t("map.qing"), //清
        1949: {
          style: {
            marginLeft: "10px",
          },
          label: this.$t("map.min"), //民国
        },
      };
    },
  },
  created() {},
  mounted() {
    this.initmap(); //加载地图
    var d = new Date();
    this.maxYear = d.getFullYear();
    // 获取庙宇列表
    this.getTempleList();
  },
  methods: {
    //加载地图ss
    initmap() {
      let that = this;
      let map = this.$leaflet.map("map", {
        minZoom: 2,
        maxZoom: 18,
        // 范围限制
        maxBounds: [
          [90, -270],
          [-90, 360],
        ],
        center: [34.1618, 104.9414],
        zoom: 3,
        zoomControl: false,
        attributionControl: false,
        // noWrap: true,
        // crs: this.$leaflet.CRS.EPSG4326,
        // crs: crs,
        preferCanvas: true,
        // layers: [osmLayer, stamenLayer],
      });
      this.$leaflet.tileLayer(this.common.mapurl).addTo(map);

      map._onResize(); // 解决地图显示不全
      let scale = this.$leaflet.control // 比例尺
        .scale({ maxWidth: 200, metric: true, imperial: false })
        .addTo(map);

      // 点击显示坐标
      map.on("click", function (e) {
        let a = [e.latlng.lat, e.latlng.lng];
        console.log(a);
        // that.a.push(a);
        // console.log(that.a);
        that.rightBtn = false;
        //关闭信息面板
        that.$refs.moreinfoRef.hide();
      });

      this.maps = map; //data上需要挂载
    },

    //获取庙宇列表
    getTempleList() {
      // 先取vuex里的数据，没有则重新请求
      let temple = this.$store.state.temple.templeData;
      if (temple.length > 0) {
        this.geoData = this.common.toGeojson(temple);
        this.templeNum = this.geoData.features.length;
        this.addPoint();
      } else {
        let pardata = { state: "1" };
        this.$Loading.show();
        this.http.post("temple/getTempleList", pardata).then((res) => {
          this.$Loading.hide();
          if (res.code == "0") {
            // 存储到svuex
            this.$store.state.temple.templeData = res.data;
            this.geoData = this.common.toGeojson(res.data);
            this.templeNum = this.geoData.features.length;
            // this.maxYear = this.geoData.features.length;
            this.addPoint();
            // this.$message({
            //   message: "获取庙宇信息成功",
            //   type: "success",
            // });
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    // 加载geojson 添加到地图上
    addPoint() {
      var that = this;
      // 加载geojson
      this.pointGroup = this.$leaflet
        .geoJSON(this.geoData, {
          pointToLayer: function (feature, latlng) {
            return that.$leaflet.circleMarker(latlng, that.pointOptions);
          },
          onEachFeature: that.onEachFeature,
        })
        .addTo(that.maps);
    },

    // 鼠标事件
    onEachFeature(feature, layer) {
      var that = this;
      layer.bindPopup(feature.properties.name); // 弹窗内容
      // 鼠标悬停
      layer.on("mouseover", function (e) {
        this.openPopup(); // 显示弹窗
        // 修改样式
        layer.setStyle({
          radius: 8,
          fillColor: "rgb(43, 185, 241)",
          color: "#fff",
        });
      });
      // 鼠标移出，
      layer.on("mouseout", function (e) {
        // 关闭弹窗
        // this.closePopup();
        // 恢复样式
        layer.setStyle({
          radius: 6,
          fillColor: "#f14d2b",
          color: "#333",
        });
      });

      // 鼠标点击 打开详细属性框
      layer.on("click", function (e) {
        // 记录当前点击的信息
        that.clickInfo = feature.properties;
        // console.log(that.clickInfo);
        //打开信息面板
        that.$refs.moreinfoRef.show();
      });

      // 点击地图时 关闭窗口
      // that.maps.on("click", function (e) {
      //   let a = [e.latlng.lat, e.latlng.lng];
      //   console.log(a);
      //   that.rightBtn = false;
      //   //关闭信息面板
      //   that.$refs.moreinfoRef.hide();
      // });
    },
    // 定位点位
    zoomIn(coordinates) {
      this.maps.setView(coordinates, 15);
    },

    zoomOut(coordinates) {
      this.maps.flyTo(coordinates, 6);
    },

    closeAll(item) {
      let that = this;
      //关闭信息面板
      this.$refs.moreinfoRef.hide();
      //如果热力图打开，则关闭
      if (this.hotmapFlag && item != "hotmapFlag") {
        this.hotmapFlag = false;
        this.hotmapGroup.setData({
          max: 0,
          data: [{ lat: 0, lng: 0, value: -1 }],
        });
      }
      // 如果时间序列是打开的,则先关闭时间序列
      if (this.timeLineFlag && item != "timeLineFlag") {
        this.timeLineFlag = false;
        this.closetimeLine();
      }
      //如果聚类 是打开的 先关闭
      if (this.clusterFlag && item != "clusterFlag") {
        this.clusterFlag = false;
        this.clusterGroup.clearLayers();
      }
      //如果祖庙联系是打开的则关闭
      if (this.lineFlag && item != "lineFlag") {
        this.lineFlag = false;
        for (let i = 0; i < this.lineList.length; i++) {
          this.maps.removeLayer(this.lineList[i]);
        }
      }
      //如果轨迹是打开的则关闭
      if (this.roadFlag && item != "roadFlag") {
        this.roadFlag = false;
        this.maps.removeLayer(that.roadMaker);
        this.roadMaker = null;
        for (let i = 0; i < this.roadLine.length; i++) {
          this.maps.removeLayer(this.roadLine[i]);
        }
      } // 清除默认点位
      this.pointGroup.clearLayers();
    },
    //祖庙联系
    changeLine() {
      this.$Loading.show();
      // 添加曲线
      if (this.lineFlag) {
        //关闭信息面板
        this.$refs.moreinfoRef.hide();
        // 清除所有模式
        this.closeAll("lineFlag");
        this.addPoint();
        var that = this;
        this.lineList = []; //清空数组
        for (let i = 0; i < this.geoData.features.length; i++) {
          //暂时存储终点坐标
          let item = this.geoData.features[i];
          let endCoordinates = [
            item.properties.latitude,
            item.properties.longitude,
          ];
          // // 调用曲线绘制函数，获取两点之间曲线坐标组
          // //根据父庙id查询信息
          // //filter 返回的是数组形式，下面会将其变为对象形式
          // let fatherData = this.geoData.features.filter((val) => {
          //   return val.properties.id == item.properties.fatherId;
          // });
          // //如果无父庙id，则默认连接到妈祖祖庙
          // if (!fatherData[0]) {
          //   fatherData = this.geoData.features[0];
          // } else {
          //   fatherData = fatherData[0]; //将fatherData变为对象形式,即取第一个数组
          // }
          // 父庙坐标
          let fatherCoordinates = [
            item.properties.father_latitude,
            item.properties.father_longitude,
          ];

          // 父庙name
          let fatherName = item.properties.name;
          let qLine = this.common.calcCoorArr(
            fatherCoordinates,
            endCoordinates,
            20
          );

          //传入参数： 祖庙坐标、终点坐标、曲线点数
          // 将曲线坐标组添加到地图上，绘制曲线
          let nline = this.$leaflet
            .polyline(qLine, {
              color: "rgb(43, 185, 241)",
              weight: 3,
              opacity: 0.4,
            })
            .addTo(this.maps)
            .bindPopup(
              fatherName + "——" + that.geoData.features[i].properties.name
            );

          // 将绘制的曲线存入总数组，方便清除
          this.lineList.push(nline);
          // 鼠标监听
          nline.on("mouseover", function (e) {
            // 显示弹窗
            // this.openPopup();
            // 修改样式
            nline.setStyle({
              color: "#f14d2f",
              weight: 5,
              opacity: 1,
            });
          });
          // 鼠标移出，
          nline.on("mouseout", function (e) {
            // 关闭弹窗
            this.closePopup();
            // 恢复样式
            nline.setStyle({
              color: "rgb(43, 185, 241)",
              weight: 3,
              opacity: 0.4,
            });
          });
        }
      } else {
        // 清除
        for (let i = 0; i < this.lineList.length; i++) {
          this.maps.removeLayer(this.lineList[i]);
        }
      }
      this.$Loading.hide();
    },
    // 聚类模式
    changecluster() {
      var that = this;
      // 打开聚类图层
      if (this.clusterFlag) {
        this.$Loading.show();
        // 清除所有模式
        this.closeAll("clusterFlag");
        let cluster = this.$leaflet.markerClusterGroup();
        // 使用geojson创建基础maker
        this.clusterGroup = that.$leaflet.geoJSON(that.geoData, {
          pointToLayer: function (feature, latlng) {
            return that.$leaflet.circleMarker(latlng, that.pointOptions);
          },
          onEachFeature: that.onEachFeature,
        });
        // 将基础maker添加到聚类图层
        cluster.addLayer(that.clusterGroup);
        // 复制聚类图层，方便删除操作
        this.clusterGroup = cluster;
        // 将聚类图层添加到地图上
        that.maps.addLayer(this.clusterGroup);
      } else {
        this.clusterGroup.clearLayers();
        this.addPoint();
      }
      this.$Loading.hide();
    },

    //热力图层
    changehotMap() {
      this.$Loading.show();
      //首次加载，生成热力图点位
      if (!this.hotPoint) {
        //热力图初始设置
        let hotOptions = {
          //仅当scaleRadius为真（或预期为小半径）时，半径才应较小
          //如果scaleRadius为false，它将是以像素为单位的恒定半径
          radius: 20,
          maxOpacity: 0.7,
          //基于地图缩放缩放半径
          scaleRadius: false,
          //如果设置为false，热图将使用全局最大值进行着色
          //如果激活：使用当前地图边界内的最大数据
          //（始终会有一个红点，其中useLocalExtreme为true）
          useLocalExtrema: true, //true  权重默认为最大值，false 图案按权重显示
          latField: "lat", //数据中的哪个字段名表示纬度-默认值“lat”
          lngField: "lng", //数据中的哪个字段名表示经度-默认值“lng”
          valueField: "value", //数据中的哪个字段名表示数据值-默认“value”
        };
        this.hotmapGroup = new this.$HeatmapOverlay(hotOptions);
        this.maps.addLayer(this.hotmapGroup);
        let hotPont = {
          min: 0, //热力最小值
          max: 8, //热力最大值
        };
        let hotData = []; //点位数组、坐标以及热力值
        for (let i = 0; i < this.geoData.features.length; i++) {
          let hotOBj = {
            //暂时存储终点坐标
            lat: this.geoData.features[i].geometry.coordinates[1],
            lng: this.geoData.features[i].geometry.coordinates[0],
          };
          // hotOBj.value = Math.ceil((Math.random() * 10) % 8);
          hotOBj.value = 1; //应为    useLocalExtrema: true, 所以这里设置为1， 但显示按权重最大值显示。
          hotData.push(hotOBj);
        }
        hotPont.data = hotData;
        this.hotPoint = hotPont;
      }
      this.hotmapGroup.setData({
        max: 8,
        min: 0,
        data: [{ lat: 224.6408, lng: 46.7728, count: 8 }],
      });

      //显示热力图层
      if (this.hotmapFlag) {
        // 清除所有模式
        this.closeAll("hotmapFlag");
        this.hotmapGroup.setData(this.hotPoint);
      } else {
        //隐藏热力图层
        this.hotmapGroup.setData({
          max: 0,
          data: [{ lat: 0, lng: 0, value: -1 }],
        });
        // 添加基础点位图
        this.addPoint();
      }
      this.$Loading.hide();
    },

    // 时间面板打开时调用---
    changeTimeLine() {
      var that = this;
      try {
        //关闭信息面板
        this.$refs.moreinfoRef.hide();
      } catch (e) {}

      if (this.timeLineFlag) {
        // 清除所有模式
        this.closeAll("timeLineFlag");
        this.timeLineFlag = true;
        // 添加初始时间点位，即只显示祖庙
        this.timeGroup = this.$leaflet
          .geoJSON(this.geoData, {
            // 点位样式
            pointToLayer: function (feature, latlng) {
              return that.$leaflet.circleMarker(latlng, that.pointOptions);
            },
            // 鼠标监听
            onEachFeature: that.onEachFeature,
            // 筛选器
            filter: function (feature, layer) {
              return parseInt(feature.properties.years) <= that.minYear;
            },
          })
          .addTo(that.maps);
      } else {
        this.closetimeLine();
      }
    },

    // 开始按钮
    playBtn() {
      this.playFlag = !this.playFlag;
      if (this.playFlag) {
        this.rightBtn = false;
        this.playName = this.$t("map.pause"); // 暂停
        //that.pointGroup.clearLayers();
        this.auto();
      } else {
        this.playName = this.$t("map.start"); // 开始
      }
    },

    // 重置按钮
    resetBtn() {
      var that = this;
      // 开始按钮标记设置为false，即停止自动播放
      this.playFlag = false;
      this.playName = this.$t("map.start"); // 开始
      // timeValue 设置为最小值
      this.timeValue = this.minYear;
      this.timeGroup.clearLayers();
      // 添加初始时间点位，即只显示祖庙
      this.timeGroup = this.$leaflet
        .geoJSON(that.geoData, {
          // 点位样式
          pointToLayer: function (feature, latlng) {
            return that.$leaflet.circleMarker(latlng, that.pointOptions);
          },
          // 鼠标监听
          onEachFeature: that.onEachFeature,
          // 筛选器
          filter: function (feature, layer) {
            return feature.properties.birthday <= that.minYear;
          },
        })
        .addTo(that.maps);
    },
    // 关闭时间序列按钮
    closetimeLine() {
      clearTimeout(this.timer); //清除定时器
      this.timer = null;
      // 重置参数
      // 开始按钮标记设置为false，即停止自动播放
      this.playFlag = false;
      this.playName = this.$t("map.start"); // 开始
      // timeValue 设置为最小值
      this.timeValue = this.minYear;
      this.timeGroup.clearLayers();

      // 添加默认点位
      this.addPoint();
      // 关闭面板
    },

    // 时间轴数据绑定
    // 即当时间轴数据发生变化时调用
    timeLine() {
      let tCount = 0;
      var that = this;
      // 先清除旧的timeGroup点位，然后根据当前timeValue 筛选出符合条件的点位显示；
      this.timeGroup.clearLayers();
      this.timeGroup = that.$leaflet
        .geoJSON(this.geoData, {
          // 点位样式
          pointToLayer: function (feature, latlng) {
            return that.$leaflet.circleMarker(latlng, that.pointOptions);
          },
          // 鼠标监听
          onEachFeature: that.onEachFeature,
          // 根据条件筛选点位
          filter: function (feature, layer) {
            if (feature.properties.years <= that.timeValue) {
              tCount++;
            }
            return feature.properties.years <= that.timeValue;
          },
        })
        .addTo(that.maps);
      // console.log(tCount);
      this.timeTempleNum = tCount;
    },

    // 自动播放函数， 递归自增
    auto() {
      var that = this;
      // 当按下开始按钮
      if (this.playFlag) {
        // 延时函数，即播放的速度
        that.timer = setTimeout(() => {
          // 当前时间小于最大时间，则没500ms增加10年并调用timeLine()函数
          if (that.timeValue < that.maxYear) {
            that.timeValue += 10;
            that.timeLine();
            that.auto();
          }
          // 当前时间等于最大时间则重置当前时间为最小时间
          else {
            that.timeValue = that.minYear;
            that.timeLine();
            that.auto();
          }
        }, that.timespeed);
      }
      // 当按下暂停键则停止递归return
      else {
        clearTimeout(that.timer); //清除定时器
        this.timer = null;
        return null;
      }
    },
    // --海上丝绸之路
    changeRoad() {
      var that = this;
      if (!this.roadMaker) {
        that.maps.setView([26.086388149394875, 119.63562011718751], 3);

        let makerIcon = this.$leaflet.icon({
          iconUrl: "./static/img/maker.png", //maker图片
          shadowUrl: "./static/img/mshadow.png", //maker阴影
          iconSize: [24, 30], // 图标的大小
          shadowSize: [26, 20], // 阴影的大小
          iconAnchor: [12, 30], // 图标的点，该点将与标记的位置相对应
          shadowAnchor: [4, 18], // the same for the shadow
          popupAnchor: [2, -30], //弹出窗口相对于图标打开的点
        });
        this.roadMaker = this.$leaflet.Marker.movingMarker(
          [
            [26.066652138577403, 119.66308593750001],
            [25.730632525531913, 119.94323730468751],
            [25.289404556494823, 119.94873046875001],
            [24.841580551445354, 119.67407226562501],
            [24.661994379101575, 119.080810546875],
            [24.661994379101575, 118.69628906250001],
            [24.156778233303413, 118.58093261718751],
            [23.483400654325642, 118.15246582031251],
            [22.74578914242589, 117.32299804687501],
            [22.355156218589755, 116.25732421875001],
            [22.065278067765835, 115.13671875],
            [21.993988560906033, 114.0106201171875],
            [22.253512814974744, 113.52722167968751],
            [21.575718932458493, 113.22509765625001],
            [20.488773287109836, 112.02758789062501],
            [20.117839630491634, 110.85205078125],
            [19.932041306115536, 109.68750000000001],
            [19.84939395842279, 108.01757812500001],
            [20.2725032501349, 106.99584960937501],
            [20.58136735381002, 106.66625976562501],
            [19.435514339097825, 107.138671875],
            [16.341225619207496, 109.09423828125001],
            [13.838079936422476, 110.72021484375001],
            [10.293301000109102, 109.95117187500001],
            [7.427836528738338, 108.12744140625001],
            [4.8282597468669755, 106.12792968750001],
            [2.5260367521718403, 105.07324218750001],
            [1.3402098002785028, 104.39208984375001],
            [1.2193903597622147, 103.97460937500001],
            [1.4225833069396439, 103.05725097656251],
            [3.2666614116116146, 100.43151855468751],
            [5.922044619883305, 97.294921875],
            [6.577303118123887, 94.70214843750001],
            [6.577303118123887, 91.58203125000001],
            [4.915832801313164, 88.63769531250001],
            [3.381823735328289, 85.95703125000001],
            [3.2502085616531686, 81.07910156250001],
            [5.134714634014467, 78.79394531250001],
            [8.276727101164047, 78.96972656250001],
            [9.709057068618208, 80.81542968750001],
            [11.30770770776545, 84.63867187500001],
            [13.368243250897299, 87.01171875],
            [17.18277905643184, 87.80273437500001],
            [21.69826549685252, 87.626953125],
            [18.771115062337024, 90.30761718750001],
            [12.726084296948196, 91.36230468750001],
            [7.144498849647335, 89.4287109375],
            [1.098565496040652, 87.27539062500001],
            [-4.34641127533318, 82.96875000000001],
            [-8.320212289522944, 77.38769531250001],
            [-10.141931686131018, 67.14843750000001],
            [-8.320212289522944, 54.53613281250001],
            [-5.00339434502215, 44.9560546875],
            [-2.67968661580376, 40.20996093750001],
            [-1.2743089918452106, 46.1865234375],
            [1.8014609294680355, 52.42675781250001],
            [7.623886853120049, 53.876953125],
            [12.683214911818666, 51.28417968750001],
            [12.211180191503997, 45.52734375000001],
            [12.425847783029134, 43.54980468750001],
            [21.00247105435674, 38.18847656250001],
            [26.70635985763354, 34.89257812500001],
            [31.765537409484374, 31.201171875000004],
            [35.35321610123823, 27.158203125000004],
            [35.92464453144099, 24.0380859375],
            [35.67514743608467, 21.533203125000004],
            [37.71859032558816, 19.204101562500004],
            [39.94343646197423, 18.984375000000004],
            [42.06560675405716, 16.831054687500004],
            [43.51668853502909, 14.326171875000002],
            [44.308126684886126, 11.601562500000002],
            [43.644025847699496, 7.822265625000001],
            [51.92055564515695, 4.454956054687501],
          ],
          10000,
          { icon: makerIcon, draggable: false }
        ).addTo(that.maps);
      }
      if (this.roadFlag) {
        //关闭信息面板
        // 清除所有模式
        this.closeAll("roadFlag");

        // let cityName = [
        //   [26.07652055985697, 119.32250976562501],
        //   [24.86650252692691, 118.58642578125001],
        //   [23.0999442125314, 113.30200195312501],
        //   [20.045610827439717, 110.32470703125001],
        //   [21.022982546427425, 105.82031250000001],
        //   [3.0966358718415634, 101.67846679687501],
        //   [6.875760407803935, 79.95717019350901],
        //   [22.471954507739227, 88.34106445312501],
        //   [-1.3402098002785028, 36.78222656250001],
        //   [37.94419750075404, 23.642578125000004],
        //   [45.39844997630411, 12.337646484375002],
        //   [51.92055564515695, 4.454956054687501],
        // ];
        // var makerIcon = that.$leaflet.icon({
        //   iconUrl: "./static/img/maker.png", //maker图片
        //   shadowUrl: "./static/img/mshadow.png", //maker阴影
        //   iconSize: [24, 30], // 图标的大小
        //   shadowSize: [26, 20], // 阴影的大小
        //   iconAnchor: [12, 30], // 图标的点，该点将与标记的位置相对应
        //   shadowAnchor: [4, 18], // the same for the shadow
        //   popupAnchor: [2, -30], //弹出窗口相对于图标打开的点
        // });
        // // // 添加一个不可移动的maker，用来表示妈祖庙位置
        // // var marker = that.$leaflet.marker(a, { icon: makerIcon }).addTo(map);

        // var cityLayers = [];
        // for (let i = 0; i < cityName.length; i++) {
        //   let marker = that.$leaflet
        //     .marker(cityName[i], { icon: makerIcon })
        //     .bindPopup("坐标")
        //     .openPopup();
        //   cityLayers.push(marker);
        // }

        // let cityGroup = that.$leaflet.layerGroup(cityLayers);
        // that.maps.addLayer(cityGroup);

        // 延时300ms 等待icon加载
        setTimeout(() => {
          this.roadMaker.start();
        }, 300);
        let path = []; // 声明绘制线的临时使用变量

        this.roadMaker.on("move", (res) => {
          // 监听点位移动事件 move
          that.maps.panTo([res.latlng.lat, res.latlng.lng]); //回调中会返回经纬度信息，点移动改变地图中心点
          path.length > 1 && path.shift(); // 保持数组长度，避免过度push不断重新绘制之前的路径
          path.push([res.latlng.lat, res.latlng.lng]); // 将数据push到数组中
          let nLine = that.$leaflet
            .polyline(path, { color: "rgb(115, 182, 107)", weight: 2 })
            .addTo(that.maps); // 绘制线到地图图层

          // let decorator = that.$leaflet
          //   .polylineDecorator(nLine, {
          //     patterns: [
          //       // defines a pattern of 10px-wide dashes, repeated every 20px on the line
          //       {
          //         offset: 0, // 起始位置距离线条两端的距离
          //         repeat: 2600, // 重复的间隔
          //         symbol: that.$leaflet.Symbol.dash({
          //           pixelSize: 3, // 大小
          //           // headAngle: 75, // 角度
          //           polygon: false,
          //           pathOptions: {
          //             //  stroke: true,
          //             weight: 2,
          //             color: "rgb(241, 77, 43)",
          //           },
          //         }),
          //         // symbol: that.$leaflet.Symbol.dash({ pixelSize: 10 }),
          //       },
          //     ],
          //   })
          //   .addTo(that.maps);

          that.roadLine.push(nLine);
          // that.roadLine.push(decorator);
        });

        // 这里我做了一个轨迹回放结束事件 end
        this.roadMaker.on("end", function () {
          // closeOnClick: false 点击别处不会消失
          that.roadMaker
            .bindPopup("<b>海上丝绸之路</b>", { closeOnClick: true })
            .openPopup();

          setTimeout(() => {
            that.maps.setView([34.1618, 77.136315], 3);
          }, 500);
        });
      } else {
        this.maps.removeLayer(that.roadMaker);
        this.roadMaker = null;
        // 清除
        for (let i = 0; i < this.roadLine.length; i++) {
          this.maps.removeLayer(this.roadLine[i]);
        }
        this.addPoint();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/_common.scss";

.base_box {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.container {
  z-index: 99;
  border: 0;
  width: 100%;
  height: 100%;
  background-color: rgb(217, 232, 255);
}

.right_menu_close {
  margin-right: calc(-13rem - 1px);
}
// 右侧菜单
.right_menu {
  z-index: 100;
  width: 13rem;
  height: calc(100vh - $head-height);
  right: 0;
  top: $head-height;
  position: absolute;
  border-radius: $r-min 0 0 $r-min;
  background-color: $c-glass-white;
  backdrop-filter: $d-glass;
  border-left: $b-glass;
  box-shadow: $shadow;
  transition: margin-right 0.5s;
  font-size: $f-lit;
  //右侧按钮
  .right_menu_btn {
    float: left;
    margin-left: -1.4rem;
    margin-top: $m-mid;
    color: $c-main;
    top: 3rem;
    width: 1.4rem;
    text-align: center;
    border-radius: $r-min 0 0 $r-min;
    font-size: $f-big;
    box-sizing: border-box;
    z-index: 101;
    padding: 0;
    background-color: $c-glass-white;
    backdrop-filter: $d-glass;
    border-bottom: $b-glass;
    box-shadow: $shadow;
    box-sizing: border-box;
    cursor: pointer;
  }

  .right_title {
    color: $c-main;
    border-bottom: $b-border;
    text-align: center;
    // line-height: 1rem;

    width: 90%;
    margin: 0 auto;
    padding: 2rem 0;
  }
  .right_menu_item {
    width: 90%;
    margin: $m-lit auto;
    padding: $m-mid;

    i {
      color: $c-main;
      margin-right: 0.2rem;
    }
    .btn {
      line-height: 1.2rem;
    }
    .btn:hover {
      color: $c-main;

      i {
        color: $c-second;
      }
    }
    div {
      color: $c-text-main;
      opacity: 0.8;
      line-height: 2rem;
      height: 2rem;
      cursor: pointer;
      box-sizing: border-box;
      // &:hover {
      //   border-bottom: $b-border;
      // }
    }

    .switch {
      display: flex;
      align-items: center;
      // justify-content: center;

      line-height: 1.2rem;
      margin: 0.6rem 0;
      span {
        margin-left: $m-lit;
      }
    }
  }
}
//时间序列
.time_box {
  z-index: 999;
  position: absolute;
  bottom: $m-min;
  left: $m-min;
  width: 40rem;
  height: 10rem;
  background: $b-glass-card;
  //玻璃质感
  // background-color: $c-glass-white;
  // backdrop-filter: $d-glass;
  // border-top: $b-glass;
  // border-right: $b-glass;
  border-radius: $r-min;
  padding: $m-lit;

  .time_title {
    color: $c-main;
    font-size: $f-big;
    margin: $m-mid;
  }

  .time_item {
    margin: $m-lit auto;
    box-sizing: border-box;
    color: $c-text-main;
    .time_btn {
      background: $b-glass-card;
      border-radius: $r-lit;
      padding: $m-lit;
      margin: 0 $m-lit;
      box-shadow: $shadow;
      cursor: pointer;
      &:hover {
        color: $c-main;
      }
    }

    .speed_box {
      box-shadow: none;
      background: none;
      display: flex;
      align-items: center;
      width: 18rem;
      display: inline-block;
      span {
        box-shadow: none;
        background: none;
      }
    }
    .temple_num {
      float: right;
      box-shadow: none;
      color: $c-second;
      background: none;
      font-size: $f-min;
      margin-left: 0.5rem;
    }
    .time_year {
      float: right;
      box-shadow: none;
      color: $c-main;
      background: none;
      font-size: $f-min;
    }
  }

  .el-slider {
    width: 98%;
    margin: 0 auto;
  }
}

@media screen and (max-width: 450px) {
  //时间序列
  .time_box {
    z-index: 999;
    position: absolute;
    width: 100%;
    height: 12rem;
    //玻璃质感
    // background-color: $c-glass-white;
    background: $b-glass-card;
    // backdrop-filter: $d-glass;
    left: 0;
    bottom: 0;
    border-radius: $r-min;
    padding: $m-lit;
    box-sizing: border-box;
    .time_title {
      color: $c-main;
      font-size: $f-big;
      margin: $m-mid;
    }

    .time_item {
      font-size: $f-lit;
      margin: $m-lit auto;
      box-sizing: border-box;
      color: $c-text-main;
      .time_btn {
        background: $b-glass-card;
        border-radius: $r-lit;
        padding: $m-lit;
        margin: 0 $m-lit;
        box-shadow: $shadow;
        cursor: pointer;
        &:hover {
          color: $c-main;
        }
      }

      .speed_box {
        font-size: $f-lit;
        box-shadow: none;
        background: none;
        display: flex;
        align-items: center;
        width: 18rem;
        display: inline-block;
        span {
          box-shadow: none;
          background: none;
        }
      }
      .temple_num {
        float: right;
        box-shadow: none;
        color: $c-second;
        background: none;
        font-size: $f-min;
        margin-left: 0.5rem;
        font-size: $f-lit;
      }
      .time_year {
        font-size: $f-lit;
        float: right;
        box-shadow: none;
        color: $c-main;
        background: none;
        font-size: $f-min;
      }
    }

    .el-slider {
      font-size: $f-lit;
      width: 95%;
      margin: 0 auto;
    }
  }
}
</style>